import React from "react";

import classnames from "classnames";
import _ from "underscore";

import { DropdownButton } from "Cobalt/Dropdown";

import DropdownSubmenuFilter from "./DropdownSubmenuFilter";

type Props = {
  filterConfig: any;
  onChangeFilter: (arg0: string, arg1: any) => void;
  menuTitle: string;
  menus: Array<Record<string, any>>;
  menuTitle: string;
};

class DropdownMultiMenuFilter extends React.Component<Props> {
  componentDidMount() {
    this.setFilterUsedState();
  }

  setFilterUsedState() {
    let highlightMenu = false;
    const { filterConfig, menus } = this.props;
    menus.map((filters) => {
      const { options, filterKey, defaultSelect } = filters;
      let selectedOptions = null;
      const defaultOptions = options.map((x) => x.value);
      const listOptions = options.map((option) => option.value);
      const filterType = this.isMinMaxFilter(listOptions) ? "ranges" : "include";

      selectedOptions = (filterConfig[filterKey] ? filterConfig[filterKey][filterType] : null) || defaultOptions;

      const defaultFilters = selectedOptions && (selectedOptions.length !== listOptions.length || selectedOptions.length == 0);

      if (defaultSelect && defaultFilters) {
        highlightMenu = true;
      }
    });
    return highlightMenu;
  }

  render() {
    const { filterConfig, onChangeFilter, menus, menuTitle } = this.props;
    const highlightMenu = this.setFilterUsedState();
    const numSubMenus = menus.length;
    return (
      <div>
        <DropdownButton
          title={menuTitle}
          color={highlightMenu ? "secondary" : "white"}
          className={classnames("block border-solid border-transparent", {
            "border-blue hover:border-blue": highlightMenu,
          })}
          type="filter"
          dropdownClassName="rounded-xl"
          p={3}
          keepOpenOnSelect
          dropdownPosition="right"
        >
          {menus.map((filters, key) => {
            const { options, filterKey, defaultSelect, menuTitle } = filters;
            const defaultOptions = options.map((x) => x.value);
            const listOptions = options.map((option) => option.value);
            const filterType = this.isMinMaxFilter(listOptions) ? "ranges" : "include";
            return (
              <DropdownSubmenuFilter
                filterConfig={filterConfig}
                options={options}
                filterKey={filterKey}
                menuTitle={menuTitle}
                defaultOptions={defaultOptions}
                defaultSelect={defaultSelect}
                onChangeFilter={onChangeFilter}
                filterType={filterType}
                isLast={numSubMenus == key + 1}
                key={key}
              />
            );
          })}
        </DropdownButton>
      </div>
    );
  }

  isMinMaxFilter(listOptions: Array<any>) {
    return listOptions.length > 0 && (_.contains(Object.keys(listOptions[0]), "max") || _.contains(Object.keys(listOptions[0]), "min"));
  }
}

export default DropdownMultiMenuFilter;
